module.exports = __webpack_public_path__ + "static/media/43.2d0bd2b8.jpg";